import React, { useEffect, useRef } from "react";
import "./Careers.css";

const Careers = () => {
  const achievementsRef = useRef(null);

  const jobsList = [
    {
      id: 1,
      title: "WordPress Developer",
      type: "Full-time",
      location: "Remote",
      salary: "Competitive",
    },
    {
      id: 2,
      title: "Laravel Developer",
      type: "Full-time",
      location: "Navsari / Remote",
      salary: "Competitive",
    },
    {
      id: 3,
      title: "React Developer",
      type: "Full-time",
      location: "Navsari / Remote",
      salary: "Competitive",
    },
    {
      id: 4,
      title: "UI/UX Designer",
      type: "Full-time",
      location: "Remote",
      salary: "Competitive",
    },
    {
      id: 5,
      title: "Business Development Executive",
      type: "Full-time",
      location: "Navsari",
      salary: "Competitive",
    },
    {
      id: 6,
      title: "Next.js Developer",
      type: "Full-time",
      location: "Navsari / Remote",
      salary: "Competitive",
    },
    {
      id: 7,
      title: "Full Stack Developer",
      type: "Full-time",
      location: "Navsari / Remote",
      salary: "Competitive",
    },
  ];

  const benefits = [
    { title: "Remote First", description: "Work from anywhere in the world" },
    { title: "Flexible Hours", description: "Choose your working hours" },
    { title: "Health Coverage", description: "Comprehensive health insurance" },
    {
      title: "Learning Budget",
      description: "₹50,000 annual learning allowance",
    },
    { title: "Latest Equipment", description: "MacBook Pro & accessories" },
    { title: "Paid Time Off", description: "25 days annual leave" },
  ];

  const testimonials = [
    {
      role: "Senior Designer",
      quote:
        "I was hesitant about switching jobs, but three months in and I can honestly say this is where I should've been all along. The design team actually listens to each other, and leadership trusts us to make creative decisions without micromanaging every detail.",
      avatar: "👩‍🎨",
    },
    {
      role: "Full Stack Developer",
      quote:
        "What surprised me most wasn't just the tech stack or the projects—it was how much everyone genuinely wants to help you succeed. I've learned more in six months here than I did in two years at my last company.",
      avatar: "👨‍💻",
    },
    {
      role: "Product Manager",
      quote:
        "Finally found a place where cross-functional collaboration isn't just a buzzword. Engineering, design, and product actually work together from day one. Makes my job so much easier when everyone's aligned.",
      avatar: "👩‍💼",
    },
    // {
    //   role: "Marketing Specialist",
    //   quote: "The work-life balance here is real, not just something they say in interviews. I can actually disconnect after work and nobody bats an eye when I block my calendar for focus time.",
    //   avatar: "👨‍💼",
    // },
    // {
    //   role: "Backend Engineer",
    //   quote: "Been in tech for 8 years and this is the first place where I feel like my input matters beyond just writing code. They actually want to hear your ideas, even if you're not in a senior role.",
    //   avatar: "👩‍💻",
    // },
  ];

  useEffect(() => {
    const counters =
      achievementsRef.current?.querySelectorAll(".careers-counter");
    let hasAnimated = false;

    const animateCounters = () => {
      counters?.forEach((counter) => {
        const target = +counter.getAttribute("data-target");
        const duration = 2000;
        const stepTime = 20;
        const increment = target / (duration / stepTime);
        let count = 0;

        const updateCounter = () => {
          count += increment;
          if (count < target) {
            counter.textContent =
              Math.ceil(count) + (counter.getAttribute("data-suffix") || "");
            setTimeout(updateCounter, stepTime);
          } else {
            counter.textContent =
              target + (counter.getAttribute("data-suffix") || "");
          }
        };
        updateCounter();
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting && !hasAnimated) {
          animateCounters();
          hasAnimated = true;
        }
      },
      { threshold: 0.4 },
    );

    if (achievementsRef.current) {
      observer.observe(achievementsRef.current);
    }

    const allElements = document.querySelectorAll(
      ".careers-page section:not(.careers-hero-section)",
    );

    const scrollObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("scroll-show");
            scrollObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 },
    );

    allElements.forEach((el) => {
      el.classList.add("scroll-hidden");
      scrollObserver.observe(el);
    });

    return () => {
      observer.disconnect();
      scrollObserver.disconnect();
    };
  }, []);

  return (
    <div className="careers-page">
      {/* Hero Section */}
      <section className="careers-hero-section">
        <div className="careers-hero-label">CAREERS</div>
        <h1>Build the Future with Us</h1>
        <p>
          Join a team of passionate creators building digital experiences that
          matter. We're looking for talented individuals ready to make an
          impact.
        </p>
        <a href="#positions" className="btn careers-hero-btn">
          View Open Roles
        </a>
      </section>

      {/* Stats Bar */}
      <section className="careers-stats-bar" ref={achievementsRef}>
        <div className="careers-stat-item">
          <div
            className="careers-counter careers-stat-number"
            data-target="150"
            data-suffix="+"
          >
            0+
          </div>
          <div className="careers-stat-label">Projects Completed</div>
        </div>
        <div className="careers-stat-item">
          <div
            className="careers-counter careers-stat-number"
            data-target="12"
            data-suffix="+"
          >
            0+
          </div>
          <div className="careers-stat-label">Team Members</div>
        </div>
        <div className="careers-stat-item">
          <div
            className="careers-counter careers-stat-number"
            data-target="95"
            data-suffix="%"
          >
            0%
          </div>
          <div className="careers-stat-label">Client Satisfaction</div>
        </div>
      </section>

      {/* Positions */}
      <section className="careers-positions-section" id="positions">
        <h2>Open Positions</h2>
        <div className="careers-jobs-list">
          {jobsList.map((job) => (
            <div key={job.id} className="careers-job-item">
              <div className="careers-job-info">
                <div className="careers-job-title">{job.title}</div>
                <div className="careers-job-meta">
                  <span>📍 {job.location}</span>
                  <span>⏰ {job.type}</span>
                  <span>💰 {job.salary}</span>
                </div>
              </div>
              <a
                href="/contact"
                className="careers-job-apply"
                style={{ pointerEvents: "none" }}
              >
                Apply Now
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* Benefits */}
      <section className="careers-benefits-section">
        <h2>Why Join Us</h2>
        <div className="careers-benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="careers-benefit-card">
              <div className="careers-benefit-title">{benefit.title}</div>
              <div className="careers-benefit-description">
                {benefit.description}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <section className="careers-testimonials-section">
        <h2>Hear from Our Team</h2>
        <div className="careers-testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="careers-testimonial-card">
              <div className="careers-testimonial-avatar">
                {testimonial.avatar}
              </div>
              <div className="careers-testimonial-quote">
                "{testimonial.quote}"
              </div>
              {/* <div className="careers-testimonial-name">{testimonial.name}</div> */}
              <div className="careers-testimonial-role">{testimonial.role}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Culture */}
      <section className="careers-culture-section">
        <h2>Our Culture</h2>
        <p className="careers-culture-text">
          We believe in creating an environment where creativity thrives, ideas
          are valued, and every team member has the opportunity to grow and make
          an impact.
        </p>
        <div className="careers-culture-values">
          <div className="careers-culture-value">
            <h4>Innovation</h4>
            <p>We encourage experimentation and embrace new ideas</p>
          </div>
          <div className="careers-culture-value">
            <h4>Collaboration</h4>
            <p>We work together to achieve extraordinary results</p>
          </div>
          <div className="careers-culture-value">
            <h4>Growth</h4>
            <p>We invest in continuous learning and development</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="careers-cta-section">
        <h2>Ready to Join?</h2>
        <p>Take the next step in your career journey with OnenessWeb</p>
        <a href="/contact" className="btn careers-cta-btn">
          Get in Touch
        </a>
      </section>
    </div>
  );
};

export default Careers;
